import "./App.css";
import "./assets/fonts/fontawesome-v5.8.1/css/style.css";
import "./util/amplify";

import React from "react";
import { BrowserRouter } from "react-router-dom";
import { GeneralContextProvider } from "./context/GeneralContext";
import { AuthProvider } from "./context/AuthContext";
import Routes from "./routes";
import { AnniversaryCampaignContextProvider } from "./context/AnniversaryCampaignContext";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <GeneralContextProvider>
          <AnniversaryCampaignContextProvider>
            <Routes />
          </AnniversaryCampaignContextProvider>
        </GeneralContextProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}
